// Kept apart from config.ts so the server loader can use it without the browser config parser.
const SUPPORTED_FLOWS = ["buy"] as const;

export type SupportedWidgetFlow = (typeof SUPPORTED_FLOWS)[number];

export function isSupportedWidgetFlow(flow: string): flow is SupportedWidgetFlow {
  return SUPPORTED_FLOWS.some((supportedFlow) => supportedFlow === flow);
}
